import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore";

// Public web-app config for the setwithoutfriends Firebase project (safe to
// commit; access is controlled by Firestore security rules).
const firebaseConfig = {
  apiKey: "AIzaSyAy8IMh3-AcmuL8jQ-DQ3ClBoSd7V4DLbY",
  authDomain: "setwithoutfriends.firebaseapp.com",
  projectId: "setwithoutfriends",
  storageBucket: "setwithoutfriends.firebasestorage.app",
  messagingSenderId: "669695352110",
  appId: "1:669695352110:web:d093ba759f26fc58736ebf",
};

// If initialization fails, auth/db stay null and the game runs exactly as
// before, with the all-time stats controls hidden.
let auth = null;
let db = null;
try {
  const app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = initializeFirestore(app, {
    localCache: persistentLocalCache({
      tabManager: persistentMultipleTabManager(),
    }),
  });
} catch (error) {
  console.warn("Firebase unavailable; all-time stats disabled.", error);
}

export { auth, db };
